export const BonusGameGridView = {
  size: 100,
  gap: 0,
  name: "BonusGameGridView",
  padding: {
    top: 5,
    bottom: 5,
    left: 5,
    right: 5,
    landscape: {
      top: 3,
      bottom: 0,
      left: 5,
      right: 5,
    },
    portrate: {
      top: 3,
      bottom: 3,
      left: 3,
      right: 3,
    },
  },
  main: [
    {
      name: "empty",
      size: 3,
    },
    {
      name: "bonusgamegrid_left",
      size: 70,
      type: "PortrateGridController",
      config: {
        name: "bonus_left",
        size: 100,
        gap: 0,
        main: [
          {
            name: "empty",
            size: 14.5,
          },
          {
            name: "BonusItems",
            size: 18,
            align: "bottom_left",
            bounds: {
              width: 1144,
              height: 190,
            },
          },
        ],
      },
    },
    {
      name: "bonusgamegrid_right",
      size: 27,
      type: "PortrateGridController",
      config: {
        name: "bonus_right",
        size: 100,
        gap: 0,
        align: "left",
        padding: {
          left: 12,
        },
        main: [
          {
            name: "empty",
            size: 6,
          },
          {
            name: "fg_holder",
            size: 40,
            //height: 90,
            align: "right",
            bounds: {
              width: 155,
              height: 300,
            },
          },
          {
            name: "empty",
            size: 7,
          },
          {
            name: "win_bg_wrapper",
            align: "bottom",
            size: 8,
            bounds: {
              width: 373,
              height: 109,
            },
          },
          {
            name: "empty",
            size: 15,
          },
          {
            name: "btn_holder",
            size: 8,
            align: "right_center",
            bounds: {
              width: 280,
              height: 92,
            },
          },
        ],
      },
    },
  ],
  landscape: [
    {
      name: "empty",
      size: 3,
    },
    {
      name: "bonusgamegrid_left_landscape",
      size: 70,
      type: "PortrateGridController",
      config: {
        name: "bonus_left",
        size: 100,
        gap: 0,
        main: [
          {
            name: "empty",
            size: 15,
          },
          {
            name: "BonusItems",
            size: 18,
            align: "bottom_left",
            bounds: {
              width: 1304,
              height: 180,
            },
          },
        ],
      },
    },

    {
      name: "bonusgamegrid_right_landscape",
      size: 34,
      type: "PortrateGridController",
      config: {
        name: "bonus_right",
        size: 100,
        gap: 0,
        align: "left",
        padding: {
          right: 6,
        },
        main: [
          {
            name: "empty",
            size: 22,
          },
          {
            name: "fg_holder",
            size: 16,
            //height: 90,
            align: "center",
            bounds: {
              width: 125,
              height: 275,
            },
          },
          {
            name: "empty",
            size: 12,
          },
          {
            name: "win_bg_wrapper",
            align: "center",
            size: 10,
            bounds: {
              width: 430,
              height: 109,
            },
          },
          {
            name: "empty",
            size: 15,
          },
          {
            name: "btn_holder",
            size: 18,
            align: "right_center",
            bounds: {
              width: 295,
              height: 160,
            },
          },
        ],
      },
    },
  ],
  portrate: [
	{
		name: 'empty',
		size: 6
	},
    {
      name: "BonusItems",
      size: 18,
      bounds: {
        width: 1150,
        height: 190,
      },
    },
    {
      name: "empty",
      size: 39,
    },
    {
      name: "fg_holder",
      visible: false,
    },
    {
      name: "win_bg_wrapper",
      align: "center",
      size: 10,
      bounds: {
        width: 373,
        height: 109,
      },
    },
    {
      name: "empty",
      size: 14,
    },
    {
      name: "btn_holder",
      size: 16,
      align: "center",
      bounds: {
        width: 265,
        height: 160,
      },
    },
  ],
};
